import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import SelectButton from '../utility/SelectButton';
import { withTranslation } from 'react-i18next';

import { setBookingVehicle } from '../../actions/booking';

class VehicleItem extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { vehicle, selectedVehicleId, setBookingVehicle, t } = this.props;
    let vStr = '';
    if (vehicle.is_available === true) {
      vStr = t('form:numModelsRemaining', {
        num: vehicle.available_quantity,
        count: vehicle.available_quantity
      });
    }

    if (vehicle === null) {
      return;
    }
    return (
      <div className='fe-form-vehicle-item'>
        <div className='fe-form-vehicle-item-img'>
          <div className='fe-u-thumb-4by3'>
            <img src={vehicle.img_url} alt='' />
          </div>
        </div>
        <div className='fe-form-vehicle-info'>
          <h5 className='fe-form-vehicle-name'>{vehicle.title}</h5>
          <span className='fe-form-vehicle-desc'>{vehicle.subtext}</span>
          <br />
          {/* {vehicle.is_recommended ? (
            <span className="fe-form-vehicle-desc recommended">
              {t('gen:recommendedRanger')}
            </span>) : null} */}
          <div className='fe-form-vehicle-controls'>
            <SelectButton
              selected={vehicle.id === selectedVehicleId}
              selectedId={vehicle.id}
              onClick={() => setBookingVehicle(vehicle.id, vehicle.title)}
              disabled={vehicle.is_available !== true}
            />
            <span>{vStr}</span>
          </div>
        </div>
      </div>
    );
  }
}

VehicleItem.propTypes = {
  vehicle: PropTypes.object.isRequired,
  selectedVehicleId: PropTypes.number.isRequired,
  setBookingVehicle: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired
};

const mapStateToProps = ({ bookingState }) => ({
  selectedVehicleId: bookingState.selectedVehicleId
});

const mapDispatchToProps = {
  setBookingVehicle
};

export default withTranslation()(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(VehicleItem)
);
